@if (!isMobile) {
  <mat-tab-group
    (selectedIndexChange)="onSelectedIndexChange($event)"
    [mat-stretch-tabs]="false"
    [selectedIndex]="activeTabIndex"
    class="hidden md:flex h-full"
    id="catalog_result_wrp_tabs"
  >
    @for (searchTab of items; track customTB(i, searchTab); let i = $index) {
      <mat-tab>
        <ng-template mat-tab-label>
          <cat-result-tab-label (remove)="onRemove($event)" [index]="i"
                                [searchTab]="searchTab"></cat-result-tab-label>
        </ng-template>
        <ng-template matTabContent>
          <cat-result-tab-item [searchTab]="searchTab"></cat-result-tab-item>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
}

@if (items.length > 0 && isMobile) {
  <cat-result-toolbar
    [multiImageDownloadActive]="multiImageDownloadActive$ | async"
    [hasMultiImageDownload]="hasDownloadBatchRole"
    (clear)="onClearAll()"
    (toggleMultiImageDownload)="onToggleMultiImageDownload()"
    class="block md:hidden absolute top-2 right-5 z-[10000]"
  ></cat-result-toolbar>

  <cat-result-tab-item
    [searchTab]="items[items.length - 1]"
    class="h-full block md:hidden"
  ></cat-result-tab-item>
}

@if (items.length > 0) {
  <cat-result-toolbar
    [multiImageDownloadActive]="multiImageDownloadActive$ | async"
    [hasMultiImageDownload]="hasDownloadBatchRole"
    (clear)="onClearAll()"
    (toggleMultiImageDownload)="onToggleMultiImageDownload()"
    class="hidden md:block absolute top-8 right-5 z-50"
  ></cat-result-toolbar>
}
